import { useNavigate } from "react-router-dom";
import Navbar from "@/components/Navbar";
import { ArrowLeft, XCircle } from "lucide-react";

export default function PaymentCancel() {
  const navigate = useNavigate();
  return (
    <div className="min-h-screen bg-[#0A0A0A] glyph-bg">
      <Navbar />
      <div className="max-w-2xl mx-auto px-6 md:px-10 py-24">
        <div className="p-8 md:p-12 rounded-3xl bg-[#120E15] border border-[#F2C94C]/20 text-center" data-testid="payment-cancel-card">
          <div className="w-16 h-16 rounded-2xl bg-[#F2C94C]/15 border border-[#F2C94C]/40 flex items-center justify-center mx-auto mb-6">
            <XCircle className="w-8 h-8 text-[#F2C94C]" />
          </div>
          <h1 className="font-display text-3xl md:text-4xl text-white mb-3">Checkout cancelled</h1>
          <p className="font-body text-white mb-6">No charge — your vault is unchanged. Come back when you're ready.</p>
          <button onClick={() => navigate("/pricing")} data-testid="back-pricing-btn"
            className="font-mono-hy text-xs px-6 py-3 rounded-full bg-[#F2C94C] text-[#0A0A0A] hover:bg-[#F2D06B] transition-all flex items-center gap-2 mx-auto">
            <ArrowLeft className="w-3.5 h-3.5" /> Back to Pricing
          </button>
        </div>
      </div>
    </div>
  );
}
